export default {
    login: 'Login',
    logout: 'Logout',
    register: 'Registrati',
    upload: 'Caricamento',
    name: 'Nome',
    email: 'Email',
    password: 'Password',
    passwordConfirmation: 'Conferma della Password',
    isCommunityManager: 'Community Manager',
    dashboard: 'Dashboard',
    offerLists: 'Lista delle offerte',
    schedule: 'Programma',
    accountEdit: 'Modifica Account',
    edit: 'Modifica',
    detail: 'Dettagli',
    fullname: '{{lastname}} {{firstname}}',
    quantity: 'Quantità',
    quantityWithWeight: 'Quantità (Peso)',
    confirmTitle: 'Conferma',
    orderInformation: 'Informazioni sulla Prenotazione',
    orderPrices: 'Cronologia sulla variazione del prezzo',
    invoices: 'Fatture',
    contact: 'CONTATTI',
    when: 'Quando',
    add_to_google_calendar: 'Aggiungi a Google Calendar',
    pages: {
        dashboard: {
            unpaidInvoices: {
                title: 'Unpaid invoices (10 unpaid invoices are displayed order by expired date)',
                totalUnpaidAmountAll: 'Unpaid invoices(all)',
                totalUnpaidAmountExpired: 'Unpaid invoices(expired)',
                more: 'view all',
            },
            typicaStockItemDelaySummaryPanel: {
                title: 'TYPICA selection residency status',
                chartTitleFromImported: 'imported to purchased',
                chartTitleFromPurchased: 'purchased to delivered',
                within1month: 'within 1month',
                within2month: 'within 2months',
                within3month: 'within 3months',
                within4month: 'within 4months',
                within5month: 'within 5months',
                over5month: 'over 5month',
                unitLabel: 'Weight(Kg)',
            },
            remainingWarehouseItems: {
                title: 'Pending status of pre-orders (Lump-sum payment after the initial delivery or Pay per delivery)',
                subTitles: {
                    byPeriod: 'By Period',
                    byCommunityManager: 'By Community manager',
                    byOffice: 'By Office',
                },
                more: 'view all',
                unitLabel: 'Weight(Kg)',
            },
        },
        offerUpload: {
            title: 'Carica il CSV',
            producer: 'Producer',
            download: 'Scarica il Modello CSV',
            sampleDeliveryDateMemo: 'Deve essere 14 giorni dopo dalla data di invio possibile del campione',
            uploadMemo: 'Un rappresentante ti contatterà più tardi al termine del caricamento',
            suggestToCreateBankAccountText: "\u00C8 necessario specificare il proprio conto bancario per ricevere i proventi delle vendite, in quanto \u00E8 richiesto per l'emissione di contratti di vendita.\nSi consiglia quindi di registrarlo al momento del caricamento dell'elenco delle offerte.",
        },
        offerList: {
            title: 'La Lista delle offerte per {{country}}/{{name}}',
            createInvoices: 'Rilascio fatture',
            createInvoicesExplanation: "Le fatture saranno emesse in un'unica soluzione per coloro che sono stati registrati e i cui della tempistica dipagamento sono impostati su\n\"1. Pagamento unico come desiderato dal produttore\" nelle informazioni di prenotazione registrate.\nTuttavia, non verr\u00E0 creata alcuna nuova fattura per le prenotazioni per le quali \u00E8 gi\u00E0 stata emessa una fattura.\nL'URL della fattura creata verr\u00E0 inviato via Email a ciascun torrefazione.",
            sampleOrderStock: {
                quantity: 'Scorte di Campioni per filiale',
                lotVisibleLabel: 'Show/Hide Lot',
                show: 'Show',
                hide: 'Hide',
            },
            publishedCountriesTableTitle: 'Paese di vendita',
            basicInformations: 'Informazioni di base',
            publishedCountriesTable: 'Paese di vendita',
            transportToWarehouseTable: 'Informazioni di trasporto per singolo magazzino',
            officeDetailTable: 'Office Information',
            offersTable: 'Offerte',
            contracts: 'Contracts',
            sampleOrderPeriod: 'Richiesta di campione',
            orderPeriod: 'Richiesta di prenotazione',
            paymentPeriod: 'Tempo di pagamento',
            estimatedDeliveryPeriod: 'Consegna stimata',
            paymentAfterDelivery: 'Pagamento posticipato',
            paymentPeriods: {
                reserved: 'On order confirmation',
                exported: 'On departure from origin',
                imported: 'On arrival at destination',
                delivered: 'On delivery',
            },
            installmentPaymentAfterImport: "Pagamento a rate dopo l'ingresso nel magazzino",
            installmentPayment: 'pagamento a rate',
            estimatedPaymentDateFormat: '{{date}} {{month}} {{year}}',
            installmentPaymentsHelp: {
                title: 'Informazioni sul pagamento posticipato',
                body: "Se selezioni \"Pagamento Posticipato\" al momento della prenotazione, puoi pagare dopo la consegna.\nIl momento della prima consegna, puoi scegliere \"Pagamento unico\" o \"Pagamento Rateizzato\" per ogni consegna stocaggio in magazzino",
            },
            FreeOnBoardHelp: {
                title: 'Per FOB si intende',
                body: "Il prezzo dei chicchi di caff\u00E8 verde al momento dell'arrivo nel porto del Paese da cui parte la spedizione.\nIl trasporto marittimo e le tasse di importazione non sono inclusi.",
            },
            estimatedDeliveryPeriodFormat: '{{monthPart}} {{month}} {{year}}',
            okagesamaNoMori: 'OKAGESAMA',
            okagesamaNoMoriContributors: 'OKAGESAMA Contributors',
            okagesamaNoMoriTotalPrices: 'OKAGESAMA Total prices',
            okagesamaNoMoriStatuses: {
                title: 'OKAGESAMA Statuses',
                joined: 'Joined',
                paid: 'Joined(Paid)',
            },
        },
        editProfile: {
            title: "Modifica il profilo dell' Utente",
            subTitle: "Le Informazioni dell'Uente",
            questionnairesForRoaster: 'Questionario Relativo sul Torrefazione',
            questionnairesForRoasterMemo: '* Le seguenti informazioni possono essere modificati in seguito',
            cannotChangeCountry: '* i prega di notare che una volta che un paese è stato registrato, non può essere modificato',
        },
        editAccount: {
            title: "Modifica le Informazioni sull'Account",
            currentEmail: 'Attuale Indirizzo Email',
            warning: "Dopo aver cambiato il tuo indirizzo Email, verrai disconnesso una volta.\nUna Email di conferma verr\u00E0 inviata al tuo nuovo indirizzo Email.\nClicca sul link fornito per completare la modifica dell'account.\nSuccessivamente puoi accedere con il tuo nuovo indirizzo Email.",
        },
        exchangeRates: {
            title: 'Impostazioni del Tasso di Cambio',
            exchangeRateColumnTitle: 'Converti USD a {{currency}}',
        },
        roasterOfferLists: {
            sampleRequest: 'Richiesta del Campione',
            order: 'Prenotazione',
            inactive: 'Scaduto',
        },
        roasterOrder: {
            title: 'Prenotazione del {{ listName }}',
            explanationSelectOffers: 'Si prega di controllare la quantità di scorte nella lista sottostante e selezionare la quantità da prenotare.',
            explanationAuctionWithFobPriceUsdPerLb: "Risultati dell'asta in USD/Kg. (1kg=2.20462lb)",
            explanationStockMightChange: "* Tenere nota che l'inventario potrebbe esaurirsi mentre lo schermo è aperto.",
            order: 'Prenotazione',
            orderAmount: 'Prenotazione',
            totalFee: 'Prezzo Totale: {{ fee }} (tassa esclusa)',
            totalBags: 'Sacchi Totali: {{ amount }}',
            totalOrderedBags: 'Numero di sacchi ordinati: {{ amount }} sacchi',
            totalWeight: 'Peso totale: {{ weight }} Kg',
            totalOrderedWeight: 'Peso ordinato: {{ weight }} Kg',
            totalOneTimeUpfrontOrderedBags: 'Numero di sacchi prepagati: {{ amount }} sacchi',
            typicaHandlingFee: 'TYPICA Commissione di gestione: {{ percentage}}%',
            typicaHandlingFeeExplanationByBagCount: 'Meno di 5 sacchi; {{ lessThan5Bags }} / 5 sacchi o più {{ moreThan5Bags }} / 10 sacchi o più {{ moreThan10Bags }} / 50 sacchi o più {{ moreThan50Bags }}',
            typicaHandlingFeeExplanationByWeight: 'Meno di 300 kg: {{ lessThan300Kg }} / 300 Kg o più: {{ moreThan300Kg }} / 600 Kg o più: {{ moreThan600Kg }} / 3,000 Kg o più: {{ moreThan3000Kg }}',
            details: 'Dettagli',
            paymentAndDelivery: 'Metodo di pagamento e Indirizzo di Consegna',
            paymentMethodExplanation: "* I limiti di utilizzo della carta di credito e le condizioni di pagamento rateale variano a seconda dell'utente. Si prega di contattare la societa che ha emesso la carta per i dettagli.\n        * Notare che se l'importo fatturato in una sola volta supera le 8 cifre intere, il pagamento dovr\u00E0 consistere in un bonifico bancario.",
            endOfMonth: 'Fino alla fine di',
            oneTimeUpfrontExplanations: "- Il pagamento è previsto per {{ paymentDate }}. Per maggiori informazioni, consultare la fattura emessa al termine dell'offerta.",
            afterImportPaymentExplanations: "- Il pagamento deve essere effettuato entro 14 giorni dalla data di ingresso del caff\u00E8 in magazzino (Data approssimativa: {{ deliveryPeriod }}).\n      - La merce pu\u00F2 essere consegnata dopo che il pagamento \u00E8 stato completato.",
            fewTimesPaymentAfterImportExplanations: "- Il primo pagamento \u00E8 previsto entro 14 giorni dalla data di ingresso del caff\u00E8 in magazzino (Data approssimativa: {{ deliveryPeriod }}).\n      - La merce pu\u00F2 essere consegnata dopo il completamento del primo pagamento.\n      - Il secondo pagamento e quelli successivi sono dovuti alla fine del mese successivo all'entrata in magazzino. Per i dettagli si veda la fattura emessa all'inizio del mese.",
            paymentTimingExplanation: '* Le commissioni variano in base ai tempi di pagamento. Fare riferimento al simulatore di prezzo nella parte inferiore dello schermo per i dettagli.',
            oneTimeUpfrontRateConstraintByBagAmount: ' (alle prenotazioni minime 2 sacchi)',
            oneTimeUpfrontRateConstraintByWeight: ' (Solo per prenotazioni minime di 120 kg)',
            deliveryMethodExplanation: "* A partire dal primo giorno del secondo mese successivo alla data di ingresso nel nostro magazzino, viene addebitato un costo mensile di stoccaggio pari a {{unitPrice}} per kg.",
            oneTimeUpfrontRateByBagAmount: '(Uno sconto del {{ percentage }} * alle prenotazioni minime 2 sacchi)',
            oneTimeUpfrontRateByWeight: ' | (Uno sconto del -{{ percentage }})',
            paymentTimingNegativeRate: ' | (Uno sconto del -{{ percentage }})',
            paymentTimingPositiveRate: ' | (commissione {{ positive }}{{ percentage }})',
            addressExplanation: "* Si prega di inserire il nome dell'edificio, la scala, ecc.",
            emailExplanation: '* Assicurati di inserire correttamente il tuo indirizzo Email.',
            deliveryTimeEtcExplanation: '* Ti preghiamo di comprendere che potremmo non essere in grado di soddisfare ulteriori richieste come un determinato tempo di consegna.',
            sample: 'Campione',
            sampleOrder: 'Richiesta di campione',
            sampleOrdered: 'Prenotato',
            outOfSamples: 'Out of samples',
            bidSubmitted: 'Già offerta',
            sampleOrderableCount: 'Il numero dei LOT dei campioni richiedibili',
            inputAddress: 'Inserire indirizzo',
            simulateAndInputAddress: 'Inserire dettagli del prezzo e indirizzo',
            simulation: 'Simulazione del prezzo',
            sampleOrderCaption: 'Il Campione del seguente  LOT sarà prenotatoto',
            comment: 'Commento',
            commentHelp: '* Il tuo commento sarà condiviso con altri torrefattori e produttori.',
            translation: 'I commenti possono essere tradotti in inglese, spagnolo, giapponese, cinese e coreano.',
            postComment: 'Posta un commento',
            updateComment: 'Aggiorna commento',
            deleteComment: 'Elimina commento',
            noComments: 'Non ci sono commenti',
            cuppingScoreHelpText: 'Si prega di inserire il punteggio valutato dei protocolli e delle procedure SCA per il cupping',
            more: 'Ulteriori informazioni',
            ordered: 'prenotato',
            addInvoice: 'Crea fattura',
            preOrderExplanation: 'Il periodo della prenotazione è programmato per essere {{startedAt}} - {{endedAt}}.',
            countdownToOrder: "Manca {{countdown}} all'inizio della prenotazione",
            confirmationOfBuyPartial: "Lotto: offerta non valida se {{lotNumber}} è inferiore alla quantità indicata nell'asta",
            auctionBadgeExplanation: "Questo lotto \u00E8 in vendita a un'asta cieca.\nSi prega di inserire il prezzo di acquisto e la quantit\u00E0 desiderata.\nQualsiasi importo superiore al prezzo di partenza sar\u00E0 pagato al produttore come bonus d'asta.\nL'esito dell'asta sar\u00E0 comunicato via e-mail.\nIl numero sul badge corrisponde agli attuali acquisti desiderati.",
            okagesamaNoMoriPrice: '* Costo di partecipazione {{ priceUsd }} (circa {{ price }})',
            okagesamaNoMoriPriceText: '(Il costo della partecipazione può variare a seconda del tasso di cambio.)',
            sampleStats: 'Visuarizzazioni dai torrefattori',
            preorderStats: 'Acquistati dai torrefattori',
        },
        ordersPage: {
            title: 'Prenotazioni',
            detailsTitle: 'Pre-ordered offer lists',
        },
        sampleOrdersPage: {
            title: 'Richieste di campioni',
        },
        register: {
            accept: 'Accetti i termini',
        },
        orderedOfferLists: {
            title: 'Liste di offerte prenotate',
        },
        sampleOrders: {
            title: 'Richieste di campioni',
            import: 'Importa richieste di campioni',
        },
        sampleOrderedOfferLists: {
            title: 'La lista delle offerte dei campioni richiesti',
        },
        orderDetail: {
            orderItemsTableTitle: 'Elenco dei lotti prenotati',
            bidsTableTitle: 'Elenco dei lotti di offerta',
            changeStatus: 'Change status',
            preOrderRequestCreateOrEdit: 'Creare o modificare una richiesta',
        },
        sampleOrderDetail: {
            requestedLotNumbers: 'Numeri di Lot# dei campioni richiesti',
        },
        invoice: {
            title: 'Fattura per ordine {{orderIds}}',
            billingTo: 'Fatturazione a',
            billingAddress: 'Indirizzo Di Fatturazione',
            transparencyInformation: {
                farm: 'Produttore',
                farmExplanation: 'Per informazioni sul produttore, vedere <1>qui</1>.',
                mill: 'Mullino',
                millExplanation: "Le ciliegie/pergamena di caffè acquistate dai piccoli produttori vengono lavate nei mullini locali. Anche le spese di spedizione all'interno del paese e le dogane sono incluse in questi costi.",
                auctionBonus: "Bonus d'asta",
                auctionBonusExplanation: "In una asta cieca, la differenza del prezzo di acquisto dal prezzo iniziale di vendita sarà pagato al produttore come bonus d'asta.",
                shippingFee: 'Costo di Trasporto',
                shippingFeeExplanation: "La somma dei costi di trasporto e importazione (il costo della dogana, il costo dei controlli fitosanitari d'importazione, etc).",
                importTax: 'Tassa di importazione',
                importTaxExplanation: '{{ importTaxRate }} della somma del costo di trasporto e della merce.',
                typica: 'TYPICA',
                typicaExplanationForExclusiveLot: 'Diritti TYPICA ({{exclusiveTypicaHandlingRate}})',
                typicaExplanationByBagCount: 'Tariffa per il servizio TYPICA. (0-5 confezioni: {{ lessThan5Bags }}, 5-9 confezioni: {{ moreThan5Bags }}, 10-49 confezioni: {{ moreThan10Bags }}, oltre 50 confezioni: {{ moreThan50Bags }}).',
                typicaExplanationByWeight: 'Diritti TYPICA. (Meno di 300 kg: {{ lessThan300Kg }}, 300Kg o più: {{ moreThan300Kg }}, 600Kg o più: {{ moreThan600Kg }}, 3.000Kg o più: {{ moreThan3000Kg }})',
                typicaExplanationForTypicaSelection: 'Diritti TYPICA (40%)',
                typicaExplanationForTypicaSelectionByWeightV1: 'Drittii TYPICA. (meno di 300Kg: 40%, 300Kg o più: 35%, 600Kg o più: 30%, 3,000Kg o più: 25%)',
                typicaExplanationForTypicaSelectionByWeightV2: 'Drittii TYPICA. (meno di 300Kg: 35%, 300Kg o più: 25%, 600Kg o più: 20%, 3,000Kg o più: 15%)',
                consumptionTaxExplanation: 'Costi tassabili e {{ taxRate }} di commissioni.',
                vatReverseChargeExplanation: "Si applica l'IVA inversa (0%)",
                oldPriceVersionKgPriceNotice: 'È il prezzo unitario al kg escluse "Commissioni su Pagamento Differito (tasse escluse), Pagamento Antecipato Sconto" e "Costo di servizio (tasse escluse)".',
                newPriceVersionKgPriceNotice: 'Prezzo unitario al kg, esclusi "sconti o commissioni in funzione dei tempi di pagamento".',
                specialTypicaDiscount: 'Discount',
                specialTypicaDiscountExplanation: 'This is the total discount amount.',
                shippingFeeForJp: "Costi di spedizione dall'estero",
                shippingFeeExplanationForJp: 'Il costo dal porto di carico al porto/aeroporto di sbarco.',
                importTaxForJp: 'Costi di importazione e trasporto',
                importTaxExplanationForJp: 'Questo è il totale dei costi di trasporto e importazione (costi di dazi doganali, costi di certificazione di controllo fitosanitario, ecc.) sostenuti dal porto di arrivo al magazzino.',
                consumptionTaxExplanationForJp: "E'  la base imponibile totale dell'8% per i chicchi di caffé e del 10% per i costi di trasporto dall'estero e altri costi.",
                CoffeeCherryExplanation: 'Remarks',
                negativeBreakdownCoffeeCherryExplanation: 'As the cost of cherries of in Ethiopia continues to rise, it becomes increasingly difficult for washing stations, mills and exporters to stay profitable. {{producerName}}, however, believes that building long-term partnerships with roasters is important in the overall sustainability of the industry and so, in valuing those relationships, will be offering their coffee at an average price of the last few years, rather than raising it significantly.',
            },
            paidStatus: 'Pagamento',
            paidMessage: 'Pagato il {{paidDate}}',
            unpaidMessage: 'Si prega di pagare entro {{expiredDate}}',
            changePaymentMethod: 'Modifica del metodo di pagamento.',
            vatrcHelp: "Inserite il vostro numero di partita IVA nella schermata del profilo e verrà applicato l'addebito dell'IVA inversa.",
        },
        adminUsers: {
            title: 'Users',
        },
        adminRoasters: {
            title: 'Torrefazione',
            typicaShareRatioCalculatedAt: 'TYPICA share ratio calculated at',
        },
        adminRoasterDetail: {
            title: 'Details for {{roaster}}',
        },
        adminProducers: {
            title: 'Produttori',
        },
        adminProducerDetail: {
            title: 'Details for {{producer}}',
        },
        countryInformations: {
            title: 'Informazione sul Paese di origine',
        },
        roasterCountries: {
            title: 'Paese di vendita',
        },
        adminOrder: {
            title: 'Prenotazione Sostituita',
            selectRoaster: 'Seleziona torrefazione',
        },
        warehouses: {
            title: 'Gestione del magazzino',
        },
        warehouseItems: {
            title: 'Scorta di Magazzino',
            deliveryRequest: 'Richiesta di Consegna',
            addressInfo: 'Indirizzio di Consegna',
            selectItems: 'Si prega di selezionare il lot di cui si desidera richiedere la consegna',
            explainationForQuantity: "La quantità viene visualizzata in unità di sacco ed è diversa dall'unità di ordinazione al momento della prenotazione",
            editDeliveryRequest: {
                caption: 'Dovete modificare il vostro piano di consegna?',
                button: 'Modifica del piano di consegna',
            },
        },
        deliveryRequests: {
            title: 'Richieste di consegna',
            import: 'Input delivery charges in a batch',
        },
        deliveryRequestDetail: {
            title: 'Dettagli della richiesta di consegna',
            basicInfo: 'Informazioni di base',
            editForm: 'Modifica il modulo',
        },
        newDeliveryRequest: {
            title: 'Add New Delivery Request',
        },
        roasterWarehouseItems: {
            requestable: 'Consegnabile',
            delivered: 'Consegnato',
            delivering: 'In consegna',
        },
        offerListForum: {
            translateMessage: 'Traduci messaggio',
            changeTranslationLanguage: 'Cambia lingua di traduzione',
            languages: {
                en: 'Inglese',
                es: 'Spagnolo',
                ja: 'Giapponese',
                zh: 'Cinese',
                ko: 'Coreano',
            },
        },
        monthlyClosing: {
            title: 'Elenco di chiusura mensile',
            createButton: 'Eseguire il processo di chiusura mensile',
        },
        balanceSheetEntry: {
            title: 'Balance Sheet Entries',
            advanceReceived: 'Advance Received',
        },
        offices: {
            title: 'Ufficio',
        },
        invoicePayment: {
            title: 'Pagamento per la fattura "{{invoiceTitle}}"',
            suspendedMessage: "Siamo molto dispiaciuti.\n\nAttualmente stiamo sospendendo i pagamenti con carta di credito a causa della migrazione del nostro sistema di pagamento.\nAttendere un po' per il processo di migrazione.Vi preghiamo di effettuare il pagamento una volta completata la migrazione del sistema di pagamento o, se avete fretta, di effettuare il pagamento tramite bonifico bancario.\n",
        },
        transportToWarehouse: {
            waterActivity: "Valore dell'Attività dell'Acqua",
            moistureContent: 'Quantita di Acqua',
        },
        adminAuction: {
            title: "Stato dell'asta {{offerListName}} / {{lotNumber}}",
            auctionClosed: 'Questa asta è già terminata',
            auctionOpened: 'Questa asta è in corso',
            closeAuction: "Termina l'asta",
            confirmation: 'This auction will be closed. Bids cannot be canceled after the auction is closed. Do you want to proceed?',
        },
        roasterBids: {
            title: 'Elenco delle offerte',
        },
        roasterAuction: {
            title: "{{offerListName}} / {{lotNumber}} risultati dell'asta",
            bidQuantity: 'Il numero di offerte accettate',
            roasterAuctionResult: 'Risultato della tua offerta accettata',
            auctionResult: "Riepilogo dell'offerta accettata",
        },
        adminCreateTypicaStockItems: {
            title: 'Create TYPICA Selection',
        },
        adminTypicaStockItems: {
            title: 'TYPICA Selection',
            helpQuantity: 'The total number of typica stock. This value is reflected when creating contracts such as Shipping instructions.',
            helpRemainingQuantity: 'Quantity - Ordered Quantity + Adjustment Quantity',
            helpAdjustmentQuantity: 'For adjusting the number of items in typica stock (e.g., to reduce the number of items in stock for sample requests)',
            helpSampleRemainingQuantity: 'Sample total quantity - Sample ordered quantity',
        },
        adminNewTypicaStockOrder: {
            title: 'Proxy pre-order from TYPICA Selection',
        },
        adminTypicaStockOrders: {
            title: 'TYPICA Selection pre-orders',
        },
        adminTypicaStockSampleOrders: {
            title: 'TYPICA Selection sample requests',
        },
        adminSalesContractAndAuctionBonusInvoice: {
            title: 'Sales Contract / Auction Bonus Invoice',
        },
        adminSalesContractBankAccount: {
            title: 'Producer Bank account information for salesContract',
        },
        producerBankAccounts: {
            title: 'Elenco delle informazioni sul conto bancario',
            edit: 'Modifica delle informazioni sul conto bancario',
            new: 'Creazione di informazioni sul conto bancario',
        },
        producerOkagesamaNoMori: {
            title: 'OKAGESAMA',
        },
        adminRoasterSalesReward: {
            title: 'Roaster Sales Reward',
            netWeight: 'Weight',
            quantity: 'Quantity',
        },
        typicaSelection: {
            title: 'Selezione TYPICA',
            order: 'Visualizza i dettagli della prenotazione',
            sampleOrderPeriod: 'sempre',
            orderPeriod: 'sempre',
            paymentPeriod: 'Pagamento posticipato',
            estimatedDeliveryPeriod: 'Circa 1 settimana dopo la prenotazione',
            sampleOrder: 'Cliccare qui per richiedere un campione',
            orderFormStepper: {
                order: 'Indirizzo di pagamento e fatturazione',
                deliveryRequest: 'Dettagli della consegna',
            },
            tooltip: {
                invalidDeliveryRequestGroup: {
                    oneTime: {
                        body1: 'La data di consegna specificata è vuota',
                        body2: 'Specificare una data specifica per la consegna',
                    },
                    installment: {
                        body1: 'Ci sono ancora lotti disponibili per le richieste di consegna',
                        body2: 'Specificare tutta la tempistica di consegna frazionata',
                    },
                },
                isNotWarehousing: {
                    body1: 'Non è ancora in magazzino',
                    body2: 'Le date di consegna non possono essere specificate, tranne che per i lotti già in magazzino',
                },
                inValidDeliveryRequestItemsAndRequestDate: 'Inserire il numero di consegne o la data di consegna specificata',
            },
        },
        preOrderRequest: {
            title: "Elenco delle richieste di ripetizione dell'ordine",
            new: "Crea richiesta di ripetizione dell'ordine",
            requestedOffer: 'Requested for repeat order Lot',
            lotNumberBlank: "Richiesta all'interno dello stesso elenco delle offerte",
        },
        roasterAddresses: {
            title: 'Gestione della rubrica',
            billingAddresses: 'Indirizzo di fatturazione',
            deliveryAddresses: 'Indirizzo di spedizione',
        },
        cuppingComments: {
            title: 'Riepilogo del cupping',
            commentedBy: 'Contribuito da',
            otherRoasters: 'e {{ count }} altri torrefattori',
        },
        createCuppingComment: {
            title: 'Crea commento',
        },
        deliveryRequestItemsAndRequestDateForm: {
            title: 'Dettagli della consegna',
            subheaders: {
                oneTime: 'Consegneremo la merce in un lotto unico entro il  termine stimato.',
                installment: 'Consegneremo in lotti fino a 3 frazioni entro il termine stimato.',
                installmentCaption: 'Tempo di consegna stimato: circa 1 settimana dopo la prenotazione',
            },
            type: {
                oneTime: 'Consegna lotto unico',
                installment: 'Consegna frazionata',
            },
            changeTimings: 'Passare a {{ timing }}',
            buttons: {
                new: 'Impostare i tempi di consegna',
                add: 'Aggiungi i tempi di consegna',
            },
            captions: {
                datePicker: {
                    fastestDelivery: '* Se lasciato in bianco, la consegna avverrà nel più breve tempo possibile.',
                    main: {
                        deliveryDateExplanation: '* Può specificare una data successiva a {{ startWeek }} da oggi, ma non oltre i cinque mesi dalla data della richiesta di consegna.',
                        startWeek1: 'una settimana',
                        startWeek2: 'due settimane',
                    },
                    sub: {
                        europe: '* Si consiglia di specificare una data di consegna anticipata, poiché in alcune aree la consegna effettiva può essere ritardata in media di due settimane. Si consiglia di specificare una data di consegna anticipata.',
                        etc: '* Si consiglia di specificare una data di consegna il più presto possibile, poiché la consegna effettiva può essere ritardata fino a una settimana a seconda della località. Si consiglia di specificare una data di consegna anticipata.',
                    },
                },
                card: '* Si consiglia di effettuare consegne in lotti per garantire la freschezza. Per comodità vostora, è possibile scegliere la consegna a rate.',
            },
            dialog: {
                title: 'Di consegna',
            },
        },
        adminWarehouseHoliday: {
            title: 'Warehouse holidays',
        },
    },
    labels: {
        stock: 'Disponibilità',
        stockUnit: 'Sacchi',
        lotRef: 'LOT',
        offerListSummary: 'Riepilogo delle offerte',
        farmWithLink: 'Azienda agricola',
        curatorName: 'Nome del curatore',
        seller: 'Venditore',
        material: 'Materiale',
        story: 'Narrativa',
        period: "Periodo dell'offerta",
        activeOfferLists: 'Pubblicato',
        preparingOfferLists: 'In preparazione',
        expiredOfferLists: 'Scaduto',
        noData: 'Nessun dato',
        paymentTimingOnAdmin: 'Modalità di pagamento',
        fullAddress: 'Indirizzo',
        deliveryItems: 'Lista di consegna (lot: quantità)',
        all: 'Tutto',
        inStock: 'In magazzino',
        forum: 'Forum',
        forumDisplayName: 'Nome visualizzato nel forum',
        taxed: 'Imponibile soggetto a tassazione',
        paymentTimingHandlingFee: {
            negativeValue: 'Sconto',
            positiveValue: 'commissione',
        },
        paid: 'Pagato',
        exported: "Al momento dell'esportazione",
        imported: "Al momento dell'importazione",
        uploadContract: 'Seleziona il contratto',
        uploadDocuments: 'Selezionare i documenti che si desidera caricare',
        uploadBusinessNumberKrdocument: 'Selezionare un file  immagine',
        selectFoundingCurator: 'Input Founding curator name',
        pending: 'Indeciso',
        newRoasterCampaignDiscount: 'Sconti solo sul primo acquisto',
        couponTarget: 'Il coupon applicato',
        newRoasterCampaignUnderway: 'Promo for first-time users!',
        agree: 'Agree',
        memo: 'note',
        tradeCountryUsages: 'uso',
        tradeCountryProcessings: 'Processi / metodi di raffinazione',
        tradeCountryPriceRanges: 'fascia di prezzo',
        uneditableJoinedInOkagesamaNoMori: 'Cannot edit joined in OKAGESAMA with active offer lists',
        contributedToOkagesamaNoMori: '* Stai già partecipando a OKAGESAMA',
        default: 'Predefinito',
        billingAddress: 'Indirizzo di fatturazione',
        deliveryAddress: 'Indirizzo di spedizione',
        deliveryRequestFormRequestDate: 'Data di consegna specificata',
        fastestDeliveryRequest: 'Spedizione più velocemente possibile',
        deliveryRequestByDate: 'Spedizione per la data specificata',
        includesItems: 'Include invoice items',
        bulkDownloadMode: 'Bulk download mode',
        miscFeeForJp: 'Altre comissione *2',
        taxNodeForJpCalculation: "*1 è soggetto a tassazione dell'8% / *2 è soggetto a tassazione del 10% / *3 è esente da tasse",
    },
    buttons: {
        yes: 'Sì',
        no: 'no',
        create: 'Crea',
        update: 'Aggiorna',
        delete: 'Elimina',
        cancel: 'Cancel',
        apply: 'Apply',
        complete: 'completato',
        resetPassword: 'Resetta la password',
        changePassword: 'Cambia la password',
        reconfirmEmail: 'Reinvia una Email di conferma',
        chooseFile: 'Scegli il file',
        upload: 'Caricamento',
        calculateFixed: 'Fissa i prezzi finali',
        cancelFixed: 'Annulla i prezz finali fissati',
        pay: 'Segna come pagato',
        unpay: 'Segna come non pagato',
        downloadInvoice: 'Scarica Fattura',
        salesContractDownloadPdf: 'Scarica il Sals Contact',
        auctionBonusInvoiceDownloadPdf: 'Scarica il Auction Bonus Invoice',
        downloadCsv: 'Scarica CSV',
        deliveryRequest: 'Richiesta di consegna',
        processing: 'In lavorazione...',
        import: 'Importazione',
        addItem: 'Add Item',
        createContracts: 'Creazione del contratto',
        changeStatusTo: 'Cambia lo stato in {{status}}',
        setBankAccount: 'Impostare le informazioni sul conto bancario',
        bankAccount: 'Informazioni sul conto bancario',
        selectFoundingCurator: 'Select Founding curator',
        changeFoundingCurator: 'Change Founding curator',
        deleteFoundingCurator: 'Cancel Founding curator',
        salesReward: 'Sales Reward',
        manageCommunityManager: 'Manage Community Manager',
        stripePayment: 'Pagamento',
        taiwanApiResponse: {
            resend: 'Resend(Government Uniform Invoices)',
            update: 'Set success without resend(Government Uniform Invoices)',
            destroy: 'Remove success(Government Uniform Invoices)',
        },
        priceDetail: 'Visualizza i dettagli della prenotazione',
        setAsDefault: 'Impostazione predefinita',
        selectAll: 'Select all',
        deselectAll: 'Deselect all',
        next: 'Avanti',
        updateNow: 'Update now',
        downloadOffersCsv: 'Download all lots',
    },
    links: {
        login: 'Accedi da qui',
        register: 'Registrati da qui',
        resetPassword: 'Reimposta la password da qui',
        reconfirmEmail: 'Clicca qui per reinviare una Email di conferma',
        back: 'Torna',
        payFromHere: 'Clicca qui per pagare',
        story: 'Narrativa',
        movie: 'Film',
        privacy_policy: 'Politica sulla riservatezza',
        specified_commercial_transactions_law: 'Informazioni sulla visualizzazione in base alla Legge specifica sulle transazioni commerciali',
        tos: 'Termini di servizio',
        trackingUrl: 'Stato del trasporto',
        cookiePolicy: 'Cookie policy',
    },
    messages: {
        registerSuccess: 'Abbiamo inviato una Email a {{ email }} per confermare la validità del tuo indirizzo Email. Si prega di completare la registrazione sul link contenuto nella stessa.',
        confirmationSuccess: "Conferma dell'account riuscita. Effettua il login con l'Email e la password confermate.",
        unlockSuccess: 'Account sbloccato.',
        resetPasswordSuccess: 'Reimpostazione della password accetata.Riceverai una Email di comferma.',
        accountUpdateSuccess: 'Modifica del tuo account accetata.Riceverai una Email di conferma.',
        changePasswordSuccess: 'Modificato la Password',
        reconfirmEmailSuccess: "Rinvio della richiesta di conferma dell'Email accettata. Riceverai una Email di conferma'",
        invalidEmail: "Il formato dell'Email non è valido",
        invalidPostalCode: 'Si prega di utilizzare solo numeri per il codice postale',
        loginSuccess: "Effettuato l'accesso con successo",
        logoutSuccess: 'Disconnessione riuscita',
        uploadSuccess: 'Caricamento CSV riuscito',
        createSuccess: 'Creato con successo',
        updateSuccess: 'Aggiornato con successo',
        deleteSuccess: 'Eliminato con successo',
        updateFailure: 'Non è riuscito',
        deleteConfirm: 'Elimina. Sei davvero sicuro?',
        rejectConfirm: 'This will cancel the bid for failing the screening. Are you really sure?',
        bidCancelConfirm: "Annulli l'offerta e cancelli. Sei sicuro?",
        orderSuccess: 'Ordinazione andata a buon fine',
        typicaStockOrderSuccess: "Ordinato. Gli articoli già presenti in magazzino possono essere richiesti per la consegna dall'elenco delle scorte di magazzino.",
        sampleOrderSuccess: 'Prenotazione di campione riuscita',
        deliveryRequestSuccess: 'Abbiamo richiesto la consegna. Ti contatteremo non appena saremo pronti per la spedizione',
        cancelConfirm: 'Non puoi annullare cancellazione. Sei davvero sicuro?',
        calculateFixed: "Questo approver\u00E0 la richiesta di prenotazione del torrefazione e concluder\u00E0 il contratto di vendita.\nAssicurati che l'importo sia corretto.\nSei sicuro di voler confermare il prezzo finale?",
        calculateFixedSuccess: 'Confermati i prezzi finali per le relative prenotazioni.',
        cancelFixed: "Ci\u00F2 annuller\u00E0 il contratto di vendita stabilito con la torrefazione.\nCi sono rischi connessi alla rottura del contratto.\nSei sicuro di voler annullare?",
        cancelFixedSuccess: 'Annullate canferma dei prezzi finali per le relative prenotazioni.',
        commentSuccess: 'Commentato',
        deleteCommentConfirmTitle: 'Elimina commento',
        deleteCommentConfirmBody: 'Elimina commento. Sei davvero sicuro?',
        changePasswordTokenError: 'Tempo di reimpostazione della password scaduta. Reimposta nuovamente la password.',
        deleteInvoiceConfirmTitle: 'Elimina fattura',
        deleteInvoiceConfirmBody: 'Elimina fattura, sei proprio sicuro?',
        deleteInvoiceItemConfirmTitle: 'Elimina elemento della fattura',
        deleteInvoiceItemConfirmBody: 'Elimina elemento della fattura, sei proprio sicuro?',
        sendInvoiceMailConfirmTitle: 'Inviare una mail',
        sendInvoiceMailConfirmBody: 'Invia una Email per questa fattura alla torrefazione. Sei davvero sicuro?',
        sentSuccess: 'Email inviata correttamente',
        payConfirmTitle: 'Segna come pagato',
        payConfirmBody: 'Segna come pagato. Sei davvero sicuro?',
        unpayConfirmTitle: 'Segna come non pagato',
        unpayConfirmBody: 'Segna come non pagato. Sei davvero sicuro?',
        nRowsSelected: '{0} righe selezionate',
        noDeliveryRequest: 'Nessuna richiesta di consegna',
        invalidOrderCombination: 'La richiesta del campione e la prenotazione non possono essere effettuate contemporaneamente',
        orderExplanationTitle: 'Precauzioni relative alla prenotazione',
        sampleOrderExplanationTitle: 'Modalità per la richiesta di campioni',
        auctionOrderExplanationTitle: "Precauzioni relative alle prenotazioni d'asta",
        sampleOrderExplanationBody: "Essendo campioni in numelo limitato, si prega di richiederli solo da chi interessato ad un eventuare acquisto.\nOrganizziamo comunity cupping dove possono assagiare tutti i lotti disponibili nei vari luoghi del mondo.\nPer saperne di pi\u00F9, controllate relative informazioni sulle nostre mail.",
        deliveryTimeExplanationTitle: 'Regole per la consegna',
        deliveryTimeExplanationForUsBody: "* There are additional costs associated with last-mile delivery from RPM warehouse in NJ via Accurate Transport.\n    * Please click <0>here</0> for delivery charges and <1>here</1> for delivery time.\n    * Arranging your own local shipping company or picking up at the warehouse are also possible. If so, please indicate this in the Note.\n    * Delivery could be delayed by logistical problems.\n    * Please feel free to ask if you have any questions.",
        deliveryTimeExplanationBody: "* Le spese di spedizione nazionali verranno addebitate separatamente.\n* Potrebbe subire ritardi rispetto alla data di consegna prevista a causa delle circostanze della rete di distribuzione.\n* In caso di domande, non esitare a contattarci.\n* Verr\u00E0 addebitato un costo separato per la consegna dal nostro magazzino olandese.\n* La nostra societ\u00E0 affiliata, CTS Group, gestir\u00E0 la consegna  alla tua torrefazione.\n* Si prega di consultare <0>questo file</0> per le spese di spedizione.\n* I sacchi di peso pari o superiore a 23 kg vengono sempre consegnati su pallet secondo le normative UE.\n* Poich\u00E9 nessun altro articolo viene posizionato sopra il caff\u00E8 acquistato (Non Impilabile), le spese di spedizione partiranno da 3/4 euro a pallet.",
        orderExplanationForUsBody: "* Please refer to <0>our terms and conditions</0> before proceeding with pre-orders.\n\n    * Pre-order pricing is ex-warehouse.\n    There are additional costs associated with last-mile delivery from RPM warehouse in NJ via Accurate Transport.\n    Please see <1>this file</1> for delivery costs by destination in NYC area.\n    Kindly note that shipping fees for delivery outside of New York, New Jersey, Maryland, Delaware, and Washington D.C. will be confirmed once we obtain a quote from the delivery company.\n\n    * An estimated delivery date may be delayed due to circumstances in production areas or distribution channels.\n\n    * The quality of the product shall be the same as the sample.\n\n    * As green coffee production is strongly affected by the situation and climate of production areas, conditions may be subject to change. Please note that this pre-order does not immediately guarantee the conclusion of your order. We will send you confirmation of your order after the end of a pre-order period.",
        orderExplanationBody: "* Assicurati di controllare i <0>Termini di servizio</0> prima di effettuare una prenotazione.\n\n* Verranno aggiunti ulteriori costi per la consegna dal nostro magazzino nei Paesi Bassi. Consulta <1>questo file</1> per vedere i costi di consegna.\n\n* A seconda dell'area di produzione e delle condizioni di trasporto, potrebbe essereci un ritardo nella consegna stimata.\n\n* La qualit\u00E0 del prodotto deve essere la stessa del campione.\n\n* La produzione di chicchi di caff\u00E8 \u00E8 fortemente influenzata dalle condizioni della zona di produzione e dal clima, quindi le condizioni possono variare. Questa prenotazione non garantisce suo completamento. Ti informeremo sullo stato della prenotazione entro termine ultimo indicato.",
        createdInvoices: '{{count}} fatture sono state create',
        orderNotStarted: "L'accettazione della prenotazione inizia da {{ startedAt }}",
        createContractsTitle: 'Preparation of contract documents',
        createContractsBody: "This will create the templates for the contract documents.\nPlease make sure that you have not forgotten to create TYPICA Stock.\nDo you want to proceed?",
        changeContractStatusToPublished: 'Set to Published. If you make it issued, it will be published to the producer and you will be notified by email. Are you sure?',
        changeContractStatusToDraft: 'Set to draft. Are you sure?',
        salesContractDownloadExplanationTitle: 'Per scaricare il Sales Contract',
        salesContractDownloadExplanationBody: "Prima di scaricare il Sales Contract, \u00E8 necessario impostare i dati del conto bancario.\nSeleziona i dati del conto bancario e includere eventuali note aggiuntive.",
        addBankAccountInformation: "Prima di scaricare il Sales Contract, \u00E8 necessario impostare i dati del conto bancario.\nRegistra i dati del vostro conto bancario tramite il link sottostante.",
        createBankAccount: 'Informazioni sul conto bancario creato',
        orderedOfferNotExist: 'Nessun lotto riservato',
        stripeConfirmBody: 'Pagamento.Sei sicro di voler procedere?',
        updateSuccessInvoicePaid: 'Il pagamento è stato completato. Potrebbe passare del tempo prima che la fattura venga pagata.',
        deliverySampleWarningMessage: 'I campioni verranno spediti solo dopo che è arrivata la merce. La data di arrivo è {{ approvalDate }}.',
        deliverySampleWarningConfirmationMessage: 'I seguenti campioni saranno spediti solo dopo il ricevimento della merce.',
        contactToTypicaMessage: 'Per contattarci, scrivete al seguente indirizzo mail.',
        contactToTypicaMailSubject: 'TYPICA Direct Trade Platform',
        selectColumns: 'Select Columns',
        exchangeRateMoreThanHighestRateOnPrevMonth: 'The exchange rate exceeds the highest rate ({{ rate }}) for the previous month. Are you sure?',
        exchangeRateLessThanLowestRateOnPrevMonth: 'The exchange rate is below the lowest rate ({{ rate }}) of the previous month. Are you sure?',
        updateRequired: 'New version {{ version }} found! Reload after 5 seconds...',
        newPlatformRegisterNotice: 'Siamo migrati alla nuova piattaforma dal 6 agosto 2024. Se desideri registrarti come nuovo utente, registrati da <0>Fai clic qui</0>.',
        newPlatformNotice: 'Migreremo alla nuova piattaforma dal 6 agosto 2024. Utilizza <0>qui</0>.',
        newPlatformSampleNotice: 'Un elenco di richieste di esempio per la nuova piattaforma è <0>Fai clic qui</0>.',
        newPlatformOrderNotice: "L'elenco delle prenotazioni per la nuova piattaforma è <0>Fai clic qui</0>.",
        newPlatformInvoiceNotice: 'La fattura per la nuova piattaforma è <0>Fai clic qui</0>.',
        newPlatformProfileNotice: "Le informazioni aggiornate qui non verranno automaticamente trasferite sulla nuova piattaforma.\nCi scusiamo per l'inconveniente, ma esegui anche l'aggiornamento alla <0>Nuova piattaforma</0>.",
    },
    errors: {
        isRequired: '{{ field}} obbligatiorio',
        invalid: '{{ field }} non è valido',
        positive: '{{ field }} deve essere maggiore di zero',
        integer: '{{ field }} deve essere un numero',
        decimal: '{{ field }} deve essere un numero e decimale',
        alphanumeric: '{{ field }} deve essere alfanumerico',
        invalidPostalCode: 'Postal code must be alphanumeric 7 characters',
        invalidCity: 'City must be 12 double-byte characters or less',
        invalidAddress: '{{ field }} must be full-width {{ fullWidthMaxLength }} character/half-width {{ halfWidthMaxLength }} character or less',
        purchaseLimitError: 'Questo LOT può essere prenotato solo fino a {{ limit }}',
        lowestBidFobPriceError: 'Il prezzo inselito è inferiore al quello iniziale',
        totalFeeUpperLimitError: "Hai superato il limite di pagamento con carta di credito. Si prega di passare al bonifico bancario o suddividere l'importo totale in importi di 8 cifre o meno",
        noStock: 'Scorte Insufficiente',
        sameTypicaStockItemExists: 'Same Lot and warehouse combination already exists',
        mustOverOfferMinOrderWeight: "Inserire un peso uguale o maggiore all''ordine minimo del lotto {{ minOrder }}",
        notSelectableLessThanOrdersTotalWeight120Kg: 'Si può scegliere tra prenotazioni di 120 kg o più',
    },
    options: {
        isExists: {
            '1': 'Sì',
            '0': 'No',
        },
        isQGrader: {
            '1': 'Ho una qualifica Q Grader',
            '0': 'Non ho una qualifica Q Grader',
        },
    },
    stripePayment: {
        failure: "Pagamento fallito. Per favore, ricominciate dall'inizio.",
        afterStatusSucceeded: 'Il pagamento è già stato effettuato. Potrebbe passare del tempo prima che la fattura venga pagata.',
    },
    tradeCountryUsages: {
        filter: 'Filter',
        espresso: 'Espresso',
        omniroast: 'Omniroast',
        blend_component: 'Blend component',
    },
    tradeCountryProcessings: {
        washed: 'Washed',
        honey: 'Honey',
        natural: 'Natural',
        washed_anaerobic: 'Washed Anaerobic',
        natural_anaerobic: 'Natural Anaerobic',
        experimental: 'Experimental',
    },
    tradeCountryPriceRanges: {
        '5_to_10_dollars': '$5~10',
        '10_to_15_dollars': '$10~15',
        '15_to_20_dollars': '$15~20',
        '20_to_30_dollars': '$20~30',
        '30_dollars_or_more': '$30~',
    },
};
